import styled from "styled-components";

export const TooltipIconBtn = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
`;

export const TooltipContainer = styled.div`
  position: relative;
`;

export const TooltipOuter = styled.div`
  border-radius: 10px;
  background: #302f2f;
  padding: 13px 15px;
  position: absolute;
  bottom: -15px;
  left: 30px;
  width: 100%;
  z-index: 3000;
  width: 256px;
  @media (max-width: 480px) {
    width: 170px;
    padding: 13px 12px;
  }
  // Arrow on the left
  &::before {
    content: "";
    position: absolute;
    left: -10px;
    bottom: 20px; // adjust to align vertically
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 10px solid #302f2f; // matches background
  }
`;

// export const TooltipOuter = styled.div`
//   position: absolute;
// //   top: 50%;
//   left: 32px; /* adjust distance from icon */
//   transform: translateY(-50%);
//   width: 256px;
//   background: #302f2f;
//   border-radius: 10px;
//   padding: 13px 15px;
//   z-index: 3000;

//   @media (max-width: 480px) {
//     width: 170px;
//     padding: 13px 12px;
//   }

//   // Arrow on the left, centered vertically
//   &::before {
//     content: "";
//     position: absolute;
//     left: -10px;
//     top: 50%;
//     transform: translateY(-50%);
//     width: 0;
//     height: 0;
//     border-top: 6px solid transparent;
//     border-bottom: 6px solid transparent;
//     border-right: 10px solid #302f2f; /* same as tooltip background */
//   }
// `;

export const TooltipText = styled.p`
  color: #fff;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.08px;
  margin-top: 0px;
  margin-bottom: 0px;
  //   margin: 16px 0 22px;
  @media (max-width: 480px) {
    // margin: 5px 0 10px;
    font-size: 14px;
  }
`;
